import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  birthDays: [],
  status: "idle",
  error: null,
};

export const birthDaysByCountrySlice = createSlice({
  name: "birthDays",
  initialState,
  reducers: {
    birthDaysRequested: (state) => {
      state.status = "loading";
    },
    birthDaysRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    birthDaysRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.birthDays = action.payload;
    },
  },
});

export const {
  birthDaysRequested,
  birthDaysRequestFailed,
  birthDaysRequestSucceeded,
} = birthDaysByCountrySlice.actions;

export default birthDaysByCountrySlice.reducer;
